<template>
  <div class="online-mall-layout">
    <div class="images">
      <img class="image" src="@images/bg/om_outer_ring.gif" alt="" />
      <img class="image-inter" src="@images/bg/om_inter_ring.png" alt="" />
      <a
        v-for="(item, index) in list"
        :key="index"
        :href="`${item.url ? item.url : 'javascript:;'}`"
        :target="`${item.url ? '_blank' : ''}`"
      >
        <img
          :src="item.src"
          :class="['icon', item.cls]"
          alt=""
          @mouseenter="onMouseOver(index)"
          @mouseout="onMouseOut"
          @click="onClickJump(item.url)"
        />
      </a>

      <div v-for="(item2, index2) in list" :key="index2 + 100" :src="item2.src" alt="">
        <img v-if="showQr === index2" :class="['icon', item2.qrCls]" :src="item2.qrSrc" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showQr: -1,
      list: [
        {
          ref: 'JD',
          cls: 'location-jd',
          qrCls: 'location-jd2',
          src: require('@images/icon/om_jingdong.png'),
          qrSrc: require('@images/icon/om_qr_jingdong.png'),
          url: 'https://mall.jd.com/index-1000502548.html'
        },
        {
          ref: 'XCX',
          cls: 'location-xcx',
          qrCls: 'location-xcx2',
          src: require('@images/icon/om_xiaochengxu.png'),
          qrSrc: require('@images/icon/om_qr_xiaochengxu.png'),
          url: ''
        },
        {
          ref: 'TM',
          cls: 'location-tm',
          qrCls: 'location-tm2',
          src: require('@images/icon/om_tianmao.png'),
          qrSrc: require('@images/icon/om_qr_tianmao.png'),
          url: 'https://guangyangsp.tmall.com/'
        },
        {
          ref: 'DOUYIN',
          cls: 'location-dy',
          qrCls: 'location-dy2',
          src: require('@images/icon/om_douyin.png'),
          qrSrc: require('@images/icon/om_qr_douyin.png'),
          url: ''
        },
        {
          ref: 'PDD',
          cls: 'location-pdd',
          qrCls: 'location-pdd2',
          src: require('@images/icon/om_pdd.png'),
          qrSrc: require('@images/icon/om_qr_pdd.png'),
          url: ''
        }
      ]
    }
  },
  methods: {
    init() {
      this
    },
    onMouseOver(index) {
      this.showQr = index
    },
    onMouseOut() {
      this.showQr = -1
    },
    onClickJump(url) {
      // this.$router.resolve()
      // window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style';
</style>
